<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('totalScoreGenerate.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t('totalScoreGenerate.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-loading-banner :loading="release_loading">
        <ts-card-wrapper>
          <div class="d-flex justify-content-between">
            <div class="d-flex">
              <ts-button class="mr-2" outline color="info" @click.prevent="onReleaseScore"
                :disabled="!selectedItems.length > 0">{{ $t('totalScoreGenerate.release') }}</ts-button>
              <ts-button outline color="primary" class="ts-mr-2" @click.prevent="() => (show_form = true)">{{
                $t('totalScoreGenerate.generate') }}</ts-button>
              <ts-button outline color="primary" @click.prevent="() => (show_avg_form = true)">{{
                $t('totalScoreGenerate.generateTotalAvg') }}</ts-button>
            </div>
            <div class="d-flex">
              <ts-input v-model="search" :placeholder="$t('search')" style="width: 250px" class="inline-block" />
              <ts-button outline class="ml-2" v-tooltip="$t('filter')" @click.prevent="visible = true">
                <i class="fa fa-filter"></i>
              </ts-button>
            </div>
          </div>
          <!-- drawer -->
          <a-drawer :title="$t('filter')" placement="right" :closable="false" :visible="visible"
            @close="() => (visible = false)" :zIndex="1020" width="500px">
            <drawer-filter ref="drawer" />
            <div class="row">
              <div class="col-md-12">
                <ts-button color="primary" class="mr-2" @click.prevent="fetchData">{{ $t('view') }}</ts-button>
                <ts-button color="danger" @click.prevent="clearFilter">{{
                  $t('totalScoreGenerate.clear')
                  }}</ts-button>
              </div>
            </div>
          </a-drawer>
        </ts-card-wrapper>
        <div class="overflow-auto">
          <ts-table :columns="columns" :records="resources" :loading="loading" showCheckbox
            :checkable-condition="['is_released', false]" @check-items="onSelectScoring" :rowGroup="{
              field: 'ac_class.class_and_teacher_group'
            }">
            <template v-slot="{ record }">
              <td>{{ record.branch.branch_name_en }}</td>
              <td>{{ record.student.full_name_en }}</td>
              <td>
                {{ record.acps_name_foreign }}
              </td>
              <td>{{ record.cycle_value_text }}</td>
              <td class="text-center">{{ round(record.total_score) }}</td>
              <td class="text-center">{{ round(record.average_score) }}</td>
              <td class="text-center">
                {{
                  round(
                    record.actual_percentage ? record.actual_percentage : null
                  )
                }}
              </td>
              <td class="text-center">{{ record.ranks }}</td>
              <td class="text-center">
                <small class="label bg-green" v-if="record.is_pass">{{
                  $t('generatetotalscore.passed')
                  }}</small>
                <small class="label bg-red" v-else>{{
                  $t('generatetotalscore.failed')
                  }}</small>
              </td>
              <td class="text-center">
                {{
                  record.grading_definition != null
                    ? record.grading_definition.grade
                    : ''
                }}
              </td>
              <td>
                {{ record.ac_year != null ? record.ac_year.ac_year : '' }}
              </td>
              <td>{{ record.released_date }}</td>
              <td>
                {{
                  record.releaser !== null && record.releaser.employee !== null
                    ? record.releaser.employee.name_en
                    : ''
                }}
              </td>
            </template>
          </ts-table>
        </div>
        <div class="d-flex justify-content-end p-15">
          <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
        </div>
      </ts-loading-banner>
    </ts-card>
    <!-- form -->
    <a-modal v-if="show_form" v-model="show_form" :title="$t('totalScoreGenerate.generate')" :footer="null"
      :mask-closable="false" @cancel="() => (show_form = false)" width="400px">
      <form-component @closeModal="closeModal" />
    </a-modal>

    <!-- form -->
    <a-modal v-if="show_avg_form" v-model="show_avg_form" :title="$t('totalScoreGenerate.generateTotalAvg')"
      :footer="null" :mask-closable="false" @cancel="() => (show_avg_form = false)" width="400px">
      <FormGenerateAvg @closeModal="closeModalAvg" />
    </a-modal>

    <a-modal v-model="showCheckError" v-if="showCheckError" :footer="null" :title="$t('totalScoreGenerate.release')">
      <loadingChecking 
        :step="step" 
        :resources="checkingResult"
        @release="onRelease"
        @cancel="() => showCheckError = false"
      />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'
import DrawerFilter from './components/drawer-filter'
import loadingChecking from './components/loading-checking.vue'
import FormComponent from './form'
import FormGenerateAvg from './form-generate-avg.vue'
export default {
  name: 'totalScoreGenerate',
  components: {
    FormComponent,
    DrawerFilter,
    FormGenerateAvg,
    loadingChecking
  },
  data() {
    return {
      release_loading: false,
      step: 'Verified',
      visible: false,
      loading: false,
      show_form: false,
      show_avg_form: false,
      showCheckError: false,
      checkingError: false,
      selectedItems: [],
      checkingResult: []
    }
  },
  computed: {
    ...mapState('generateTotalScore', ['resources', 'pagination']),
    round: () => value => {
      return _.round(value, 2)
    },
    search: {
      get() {
        return this.$store.state.generateTotalScore.search
      },
      set(newValue) {
        this.$store.commit('generateTotalScore/SET_SEARCH', newValue)
        this.$store.commit('generateTotalScore/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('totalScoreGenerate.branchName') },
        { name: this.$t('totalScoreGenerate.studentName') },
        { name: this.$t('totalScoreGenerate.subProgram') },
        { name: this.$t('totalScoreGenerate.cycleValue') },
        {
          name: this.$t('totalScoreGenerate.totalScore'),
          style: 'text-align:center'
        },
        {
          name: this.$t('totalScoreGenerate.averageScore'),
          style: 'text-align:center'
        },
        {
          name: this.$t('totalScoreGenerate.actualPercentage'),
          style: 'text-align:center'
        },
        {
          name: this.$t('totalScoreGenerate.rank'),
          style: 'text-align:center'
        },
        {
          name: this.$t('totalScoreGenerate.result'),
          style: 'text-align:center'
        },
        {
          name: this.$t('totalScoreGenerate.grading'),
          style: 'text-align:center'
        },
        { name: this.$t('totalScoreGenerate.academicYear') },
        { name: this.$t('totalScoreGenerate.releaseDate') },
        { name: this.$t('totalScoreGenerate.releaseBy') }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('generateTotalScore', ['releaseCheckError', 'releaseScore']),
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('generateTotalScore/fetch', attributes)
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    async onReleaseScore() {
      this.showCheckError = true
       this.step ='Verifying'
      this.checkingResult = []
      const errors = await this.releaseCheckError(this.selectedItems)
      if (errors.length > 0) {
        this.checkingResult = errors
        return;
      }

      this.onRelease()
    },
    onRelease(){
      this.checkingResult = []
      this.step ='Releasing'
      this.$store
        .dispatch('generateTotalScore/releaseScore', this.selectedItems)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.showCheckError = false
        })
    },
    closeModal() {
      this.show_form = false
      this.fetchData()
    },
    closeModalAvg() {
      this.show_avg_form = false
      this.fetchData()
    },
    onSelectScoring(scoreItems) {
      this.selectedItems = scoreItems.map(item => item.scoring_total_id)
    },
    clearFilter() {
      this.$store.commit('generateTotalScore/RESET_FILTER')
      const drawer = this.$refs.drawer

      if(drawer) {
        drawer.clear()
      }
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ branch_id: this.branch_id })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('generateTotalScore/RESET_STATE')
    this.$store.commit('generateTotalScore/RESET_FILTER')
    next()
  }
}
</script>
